import React from 'react'
import PasswordField from '../../formFields/passwordField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <PasswordField {...fieldProps} />
))
